import {getPrivateAxios} from '../../libs';
import {Team} from './types';

export interface TeamWithMembers extends Team {
  members: {
    userId: string;
    role: 'owner' | 'member';
    createdAt: string;
    user: {
      fullName: string;
      email: string;
    };
  }[];
}

export const fetchTeams = async () => {
  return getPrivateAxios()
    .get<TeamWithMembers[]>('/teams')
    .then((r) => r.data);
};
